import { Component, OnDestroy, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { Frequency, Options, RRule } from 'rrule';
import { Subject } from 'rxjs';
import * as _ from 'lodash';
import { UtilsService } from '../../services/utils.service';
import { AuthService } from '../../services/auth.service';
import { AppointmentsService } from '../../../admin/tasks-page/tasks/appoinment/appointment.service';

export function toNativeDate(date: any): Date {
    return new Date(Date.UTC(date.getUTCFullYear(), date.getMonth(), date.getDate()));
}

export function toNativeDate2(date: Date): Date {
    return new Date(Date.UTC(date.getFullYear(), date.getMonth(), date.getDay()));
}

@Component({
    selector: 'app-recurrence',
    templateUrl: './recurrence.component.html',
    styleUrls: ['./recurrence.component.css']
})

export class RecurrenceComponent implements OnInit, OnDestroy {
    Frequency = Frequency;
    recurringForm!: FormGroup;
    dates: Date[] = [];
    count: number = 1;
    interval: number = 1;
    until: Date = new Date();
    dtStart: Date = new Date()
    today: Date = new Date();
    rruleSchedule!: string;
    private weekdayMap = [
        RRule.MO,
        RRule.TU,
        RRule.WE,
        RRule.TH,
        RRule.FR,
        RRule.SA,
        RRule.SU
    ];
    private destroy$ = new Subject();

    get f(): any {
        return this.recurringForm.controls;
    }

    constructor(
        private fb: FormBuilder,
        private _UtilsService: UtilsService,
        private _AuthService: AuthService,
        private _AppointmentService: AppointmentsService,
    ) { }

    ngOnInit(): void {
        this.today = new Date();
        this.initRecurringForm();
        //this.subscribeToFormValue();
    }

    ngOnDestroy(): void {
        //this.destroy$.next();
        this.destroy$.complete();
    }

    setStartDate(value: string): void {
        const date = this._UtilsService.date.toLocale(value);
        this.f.startDate.setValue(date)
    }

    setEndDate(value: string): void {
        const date = this._UtilsService.date.toLocale(value);
        this.f.endDate.setValue(date)
    }

    private initRecurringForm(): void {
        this.recurringForm = this.fb.group({
            startDate: [this.dtStart],
            endDate: [this.until],
            frequency: [Frequency.DAILY],
            onWeekday: this.fb.array(
                [false, false, false, false, false, false, false].map(val => this.fb.control(val))
            ),
            onMonthday: [this.today.getDate()],
            count: [this.count],
            interval: [this.interval],
            until: [this.until],
        });
    }

    onSubmit() {

        let data: any = _.cloneDeep(this.recurringForm.value);

        const options: Partial<Options> = {
            freq: data.frequency || Frequency.DAILY,
            dtstart: toNativeDate(new Date(this.dtStart) || new Date()),
            byweekday: data.frequency === Frequency.WEEKLY ?
                this.getWeekday(data.onWeekday) : null,
            bymonthday: data.frequency === Frequency.MONTHLY ? data.onMonthday  : null,
            until: toNativeDate(data.endDate != null ? (new Date(data.endDate)) : null),
        };
        if (data.interval > 1) {
            options.interval = data.interval;
        }
        if (data.count > 1) {
            options.count = data.count;
            delete options.until;
        }
        const rule = new RRule(options);
        let index = (rule.toString()).lastIndexOf(":");
        this.rruleSchedule = (rule.toString()).substring(index + 1)
        this.dates = rule.all();

        console.log(this.rruleSchedule)

        /*this.recurringForm.patchValue({
            startDate: this.today,
            endDate: this.today,
            frequency: Frequency.DAILY
        });*/

    }

    createRecurrence(){
        //esto es para testear
        let company = this._AuthService.companyId();
        let data = {
            company: company,
            recurrenceRule: this.rruleSchedule
        };

        const timeZoneOffset = new Date().getTimezoneOffset();

        //creo recurrencia
        this._AppointmentService.createRecurrenceRule(data).subscribe((result) => {
            let appt = {
                schedule: result._id,
                title: "",
                startDate: new Date(),
                endDate: new Date(),
                company: company,
                task: "65392ffce1c38d716e0ac4c6", //aca va el Id de la task
                timeZoneOffset: timeZoneOffset
            }
            //crea el appointment y si va con schedule y con task crea las tareas recurrentes con esa regla
            this._AppointmentService.createAppointment(appt).subscribe((result) => {

            });
        });
    }

    private getWeekday(byWeekday: boolean[]): any {
        const result = byWeekday
            .map((v, i) => v && this.weekdayMap[i] || null)
            .filter(v => !!v);
        return result.length ? result : null;
    }
}